import { customerById } from 'api/core'
import { searchSalesOrders } from 'api/mdl11/mdl11.services'
import { salesOrderHeaderStatusId, statusFilter } from 'Utils/constants'

const activeSalesOrderHeaderStatusIds = statusFilter.salesOrder
  .filter(
    status => status.HeaderStatusId !== salesOrderHeaderStatusId.StatusCancelada
  )
  .map(status => status.HeaderStatusId)

const normalizeId = id => (id ? String(id).toUpperCase() : id)

/**
 * Valida si la orden de compra ya está registrada para el mismo cliente
 * (por RUC/Cédula), consultando el endpoint de búsqueda de órdenes de venta
 * ya existente. Excluye las órdenes en estado "Cancelada", ya que una OC
 * cancelada no debe impedir que el cliente la reutilice. `excludeDocHeaderId`
 * permite ignorar el propio documento cuando se está regenerando/reintentando
 * una orden ya creada. Falla de forma abierta (permite continuar) si la
 * consulta no puede completarse, para no bloquear ventas por una caída de un
 * servicio de validación no crítico.
 */
export const checkDuplicateOrderNumberForCustomer = async ({
  customerId,
  orderNumber,
  companyId,
  excludeDocHeaderId,
}) => {
  if (!customerId || !orderNumber) return false

  try {
    const customerResponse = await customerById(customerId)
    const customerInfo = customerResponse?.data?.Data?.CustomerInfo
    const customerNumber = customerInfo?.IDNumber || customerInfo?.RUC
    if (!customerNumber) return false

    const searchResponse = await searchSalesOrders({
      orderNumber,
      customerNumber,
      companyId,
      headerStatusIds: activeSalesOrderHeaderStatusIds,
      ignoreDateFilter: true,
      pageNumber: 1,
      pageSize: 10,
      origin: 'va',
    })

    const results = searchResponse?.data?.Data ?? []
    const normalizedExcludeId = normalizeId(excludeDocHeaderId)
    return results.some(
      order => normalizeId(order.DocHeaderId) !== normalizedExcludeId
    )
  } catch (error) {
    console.error('Error validando duplicidad de orden de compra:', error)
    return false
  }
}
